// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__1z-5K","isFloating":"Label_isFloating__1JhIv"};